import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import FullScreenModal from 'components/consumer/FullScreenModal';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import withLoginPage from 'components/consumer/consumer-login/login-page/hoc/withLoginPage';
import OrderSummary from './OrderSummary';
const OrderDetailsModal = t0 => {
  const $ = _c(6);
  const {
    isOpen,
    onClose,
    orderId
  } = t0;
  let t1;
  if ($[0] !== orderId) {
    t1 = <FixedWidthContainer><OrderSummary order_id={orderId} /></FixedWidthContainer>;
    $[0] = orderId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isOpen || $[3] !== onClose || $[4] !== t1) {
    t2 = <FullScreenModal isOpen={isOpen} onClose={onClose}>{t1}</FullScreenModal>;
    $[2] = isOpen;
    $[3] = onClose;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
OrderDetailsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  orderId: PropTypes.string
};
export default withLoginPage(OrderDetailsModal);